<template>
  <v-container fluid tag="section">
    <v-row>
      <v-col cols="12">
        <base-material-card
          color="secondary"
          icon="mdi-trophy-outline"
          :title="title"
        >
          <v-container>
            <v-row>
              <v-col cols="12">
                <div
                  v-if="selectedDettaglio"
                  style="float: left; margin-right: 20px"
                >
                  <v-btn icon color="green" large @click="loadGara(true)">
                    <v-icon>mdi-arrow-left-circle</v-icon>
                  </v-btn>
                  {{ selectedDettaglio.titolo }}
                </div>
                <div v-else style="float: left; margin-right: 20px">
                  <v-btn icon color="green" large @click="goBack()">
                    <v-icon>mdi-arrow-left-circle</v-icon>
                  </v-btn>
                  {{ $t("back") }}
                </div>
                <v-autocomplete
                  v-model="selectedSettore"
                  :items="listSettori"
                  item-text="text"
                  item-value="value"
                  @change="loadGara"
                  dense
                  :label="$t('select_sector')"
                ></v-autocomplete>
              </v-col>
            </v-row>
            <v-row>
              <v-layout justify-center style="flex-wrap: wrap">
                <v-radio-group
                  row
                  justify-center
                  v-model="filter"
                  @change="loadGara()"
                >
                  <v-radio :label="$t('to_vote')" value="toVote"></v-radio>
                  <v-radio :label="$t('active_m_p')" value="active"></v-radio>
                  <v-radio :label="$t('all_m_p')" value="tutti"></v-radio>
                </v-radio-group>
                <v-btn
                  icon
                  color="primary"
                  large
                  style="float: right"
                  @click="loadGara()"
                >
                  <v-icon>mdi-refresh</v-icon>
                </v-btn>
                <v-btn
                  icon
                  color="primary"
                  large
                  style="float: right"
                  @click="viewPunteggiFullscreen"
                >
                  <v-icon>mdi-cast</v-icon>
                </v-btn>
                <v-btn
                  icon
                  color="primary"
                  large
                  style="float: right"
                  @click="printFoglioGara()"
                >
                  <v-icon>mdi-note-text-outline</v-icon>
                </v-btn>
                <v-btn
                  v-if="ifViewVote"
                  icon
                  color="red"
                  large
                  style="float: right"
                  @click="printPunteggi(false)"
                >
                  <v-icon>mdi-file-pdf-box</v-icon>
                </v-btn>
                <v-btn
                  v-if="ifViewVote"
                  icon
                  color="red"
                  large
                  style="float: right"
                  @click="printPunteggi(true)"
                >
                  <v-icon>mdi-file-pdf</v-icon>
                </v-btn>
              </v-layout> </v-row
            ><v-row>
              <v-col cols="12">
                <DataTables
                  @insertVote="insertVote"
                  @adminVote="adminVote"
                  @printSchedaVoti="printSchedaVoti"
                  @loadDettaglio="loadDettaglio"
                  :headers="headers"
                  :tableData="tableData"
                ></DataTables>
              </v-col>
            </v-row>
          </v-container>
        </base-material-card>
      </v-col>
    </v-row>
    <insert-punti-gara ref="insertPuntiGaraDialog" @isUpdated="loadGara" />
    <admin-punti-gara ref="adminPuntiGaraDialog" />
  </v-container>
</template>

<script>
import DataTables from "@/components/base/DataTables.vue";
import insertPuntiGara from "@/app/eventi/insertPuntiGara.vue";
import adminPuntiGara from "@/app/eventi/adminPuntiGara.vue";
import dashboardGara from "@/app/eventi/dashboardGara.vue";

export default {
  name: "riepilogo-gara",
  components: {
    DataTables,
    dashboardGara,
    insertPuntiGara,
    adminPuntiGara,
  },
  props: {
    idGara: null,
  },
  data() {
    return {
      filter: "toVote",
      title: this.$t("recap_match"),
      listSettori: [],
      selectedSettore: null,
      selectedDettaglio: null,
      ifViewVote: false,
      headers: [],
      tableData: [],
    };
  },

  methods: {
    printFoglioGara() {
      let url = "/auth/eventi/pdf/foglioGara/" + this.idGara;
      window.open(this.authorizeLink(url));
    },
    printPunteggi(fullMode) {
      if (fullMode)
        window.open(
          this.authorizeLink(
            "/auth/eventi/pdf/reportGara/" + this.idGara + "?mode=full"
          )
        );
      else
        window.open(
          this.authorizeLink(
            "/auth/eventi/pdf/reportGara/" + this.idGara + "?mode=simple"
          )
        );
    },
    insertVote(item) {
      this.$refs.insertPuntiGaraDialog.open(
        this.idGara,
        item.idGarePartecipanti
      );
    },
    adminVote(item) {
      this.$refs.adminPuntiGaraDialog.open(
        this.idGara,
        item.idGarePartecipanti
      );
    },
    printSchedaVoti(item) {
      let _ = this;
      window.open(
        _.authorizeLink(
          "/auth/eventi/pdf/prtSchedeVoto/" +
            _.idGara +
            "/" +
            item.idGarePartecipanti
        )
      );
    },
    viewPunteggiFullscreen() {
      let url = "/publicDashboard/dashboardGara/" + this.idGara;
      let route = this.$router.resolve({ path: url });
      window.open(route.href, "_blank");
    },

    openMatch(item) {
      this.selectedMatch = item.idGareDettaglio;
    },

    loadSettori() {
      let _ = this;
      _.isFetching = true;
      this.chiamataAxios("GET", "/auth/eventi/getGaraSettori/" + _.idGara).then(
        (response) => {
          // Aggiunge actions e icona validazione
          _.listSettori = response.data;
          _.isFetching = false;
          _.selectedSettore = _.listSettori[0].value;
          _.loadGara();
        }
      );
    },
    goBack() {
      this.$router.push("/portal/eventi/listGare");
    },
    loadGara(reset = false) {
      let _ = this;
      let now = new Date();
      if (!_.selectedSettore) return;
      if (reset) _.selectedDettaglio = null;

      let url = "/auth/eventi/getGara/" + _.idGara + "/" + _.selectedSettore;
      _.title = _.$t("recap_match");
      _.isFetching = true;
      this.chiamataAxios("GET", url).then((response) => {
        _.title = response.data.titolo;
        _.ifViewVote = response.data.ifViewVote;
        // Dettaglio
        _.headers = [
          { text: _.$t("match_number"), value: "ordine" },
          { text: _.$t("avatar"), value: "avatar", type: "image" },
          { text: _.$t("date"), value: "orario", type: "datetime" },
          { text: _.$t("ragSoc"), value: "matchAndRagSoc", type: "html" },
          { text: _.$t("status"), value: "iconStatus", type: "icons" },
          {
            text: _.$t("vote_state"),
            value: "progressVoti",
            type: "progressBar",
          },
          { text: _.$t("score"), value: "score", type: "html" },
          { text: _.$t("partial_score"), value: "partial", type: "html" },
          { text: _.$t("penalty"), value: "penalitaGiudici", type: "html" },
          { text: _.$t("giudice_point"), value: "listGiudiciPunti" },
          { text: _.$t("giudice_penalty"), value: "listGiudiciPenalita" },
          { text: _.$t("vote"), value: "options", type: "buttons" },
        ];

        _.tableData = [];
        for (let dettaglio of response.data.dettaglio.routine) {
          for (let partecipante of dettaglio.partecipanti) {
            let item = {};
            item.listGiudiciPunti = dettaglio.listGiudiciGara
              .map((giudice) => {
                return giudice.name + " " + giudice.surname;
              })
              .join(", ");
            item.listGiudiciPenalita = dettaglio.listGiudiciPenalita
              .map((giudice) => {
                return giudice.name + " " + giudice.surname;
              })
              .join(", ");
            item.ordine = partecipante.ordine + " (" + dettaglio.ordine + ")";
            item.avatar = partecipante.avatar;
            item.orario = partecipante.orario;
            item.matchAndRagSoc = partecipante.matchAndRagSoc;
            item.idGarePartecipanti = partecipante.idGarePartecipanti;
            if (partecipante.status === "waiting") {
              item.iconStatus = [];
            }
            if (partecipante.status === "voting") {
              item.iconStatus = [
                { icon: "mdi-scoreboard-outline", color: "yellow" },
              ];
            }
            if (partecipante.status === "closed") {
              item.iconStatus = [
                {
                  icon: "mdi-check",
                  color:
                    partecipante.votatoTutto || !response.data.ifViewVote
                      ? "green"
                      : "yellow",
                },
              ];
            }
            if (partecipante.partecipa === 0) {
              item.iconStatus = [{ icon: "mdi-close", color: "red" }];
            }

            item.progressVoti = {
              label: partecipante.statoVoti,
              value: (partecipante.totVoti * 100) / partecipante.totalToVote,
            };

            item.partial =
              '<h1 class="primary--text">' +
              (partecipante.partial ? partecipante.partial : "") +
              "</h1>";
            item.penalitaGiudici =
              '<h1 class="red--text">' +
              (partecipante.penalitaGiudici
                ? partecipante.penalitaGiudici
                : "") +
              "</h1>";
            item.score =
              '<h1 class="' +
              (partecipante.status === "closed" ? "green" : "yellow") +
              '--text">' +
              (partecipante.score ? partecipante.score : "N.D.") +
              "</h1>";
            item.options = [];
            if (partecipante.toVote && partecipante.partecipa === 1)
              item.options.push({
                icon: "mdi-clipboard-list",
                color: partecipante.votatoTutto
                  ? "green"
                  : partecipante.votato
                  ? "yellow"
                  : "primary",
                text: partecipante.votatoTutto
                  ? _.$t("show_vote")
                  : _.$t("insert_vote"),
                function: "insertVote",
              });
            if (response.data.ifViewVote) {
              item.options.push({
                icon: "mdi-printer",
                color: "green",
                text: _.$t("print_vote_table"),
                function: "printSchedaVoti",
              });
              item.options.push({
                icon: "mdi-file-edit-outline",
                color: "green",
                text: _.$t("manage_vote"),
                function: "adminVote",
              });
            }
            if (
              _.filter === "tutti" ||
              (_.filter === "active" &&
                item.status !== "closed" &&
                partecipante.partecipa === 1) ||
              (_.filter === "toVote" &&
                partecipante.toVote &&
                !partecipante.votato &&
                partecipante.partecipa === 1)
            )
              _.tableData.push(item);
          }
        }

        _.isFetching = false;
      });
    },
    loadDettaglio(item) {
      let _ = this;
      _.selectedDettaglio = item;
      _.loadGara();
    },
  },
  mounted() {
    this.loadSettori();
  },
};
</script>